import noop from "../noop";

export default function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-geo/src/clip/buffer.js
// module id = 126
// module chunks = 0 1 2 3 4